import React from 'react';
import "bootstrap/dist/css/bootstrap.css";
import '../../assets/css/style.css';
import '../../assets/css/select-search.css';

import { Formik, Form, Field, ErrorMessage } from 'formik';
import { Redirect, Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import SelectSearch from 'react-select-search'

import * as api from '../../api/api';
import * as utils from '../../utils';

class DisplaySettings extends React.Component {
    constructor(props) {
        super(props);

        let returnUrl = new URLSearchParams(this.props.location.search).get("return_url");

        this.state = {
            data: [],
            formikData: {},
            returnUrl: returnUrl,
            needRedirect: false
        };

        this.props.updateLoader({
            loaded: false,
            message: ""
        });
    }

    componentDidMount() {

        if (!api.isUserAdmin()) {
            this.setState({
                returnUrl: "/users/permission-denied",
                needRedirect: true
            });

            return;
        }

        api.makeRequest(api.getDeviceSettings(this.props.match.params.id ? this.props.match.params.id : 0)).then(
            getDataResponse => {

                // console.log(getDataResponse.data.data);
                // return;

                let formikData = {};

                getDataResponse.data.data.forEach(item => {
                    formikData[item.id] = item.value
                });

                this.setState({
                    data: getDataResponse.data.data,
                    formikData: formikData
                });

                this.props.updateLoader({
                    loaded: true
                });

            },
            error => {

                this.props.updateLoader({
                    loaded: true,
                    message: "Ошибка при получении данных: " + error
                });
            }
        );
    }

    save(data) {
        const dataToSave = this.state.data.map((setting) => ({
            id: setting.id,
            value: String(data[setting.id]),
            key: setting.key
        }));

        // console.log(dataToSave);
        // return;
        this.props.updateLoader({
            loaded: false
        });

        api.makeRequest(api.saveDeviceSettings(this.props.match.params.id, dataToSave)).then(
            response => {

                this.setState({
                    needRedirect: true
                });

                this.props.updateLoader({
                    loaded: true
                });
            },
            error => {
                this.props.updateLoader({
                    loaded: true,
                    message: "Ошибка при сохранении: " + error
                });
            }
        )
            .catch((error) => {
                this.props.updateLoader({
                    loaded: true,
                    message: "Ошибка при сохранении: " + error
                });
            });
    }

    render() {

        if (this.state.needRedirect) {
            return <Redirect to={this.state.returnUrl} />
        }

        return (
            <div>

                <h4 className="mb-4">{"Редактирование настроек устройства " + this.props.match.params.id}</h4>

                <Formik
                    initialValues={this.state.formikData}
                    //TODO: поправить
                    enableReinitialize={true}

                    validate={values => {
                        let errors = {};

                        this.state.data.forEach(item => {

                            if (item.type != "disabled") {
                                if (!values[item.id] && item.type !== "emptytext") {
                                    errors[item.id] = 'Пожалуйста, заполните это поле';
                                }
                                // else if (item.type == "number" && values[item.id] < 0) {
                                //     errors[item.id] = 'Пожалуйста, введите положительное значение';
                                // }
                            }
                        });

                        return errors;
                    }}

                    onSubmit={(values, { setSubmitting }) => {
                        this.save(values);
                    }}
                >
                    {({ isSubmitting, handleSubmit, values, setFieldValue }) => (
                        <Form>
                            {
                                this.state.data.map(item => {
                                    return (
                                        <div className="form-group">
                                            <label>{item.label}</label>

                                            {
                                                item.type == "bool" ?
                                                    <>
                                                        <Field className="form-control" name={item.id} component="select" >
                                                            <option value="true">Да</option>
                                                            <option value="false">Нет</option>
                                                        </Field>
                                                        <ErrorMessage className="form-error-message" name={item.id} component="div" />
                                                    </> :
                                                    item.type == "disabled" ?
                                                        <>
                                                            <Field className="form-control" disabled={true} type="text" name={item.id} />
                                                        </> :
                                                        <>
                                                            <Field className="form-control" type={item.type} name={item.id} />
                                                            <ErrorMessage className="form-error-message" name={item.id} component="div" />
                                                        </>
                                            }
                                        </div>
                                    )
                                })
                            }

                            <div className="d-flex">
                                {/* <button className="btn btn-primary-custom" type="submit">
                                    Сохранить
                                </button> */}

                                {/* <div className="dropdown">
                                    <button className="btn btn-primary-custom" type="button" data-toggle="dropdown">
                                        Сохранить
                                    </button>
                                    <div className="dropdown-menu dropdown-menu-right">
                                        <a class="dropdown-item dropdown-item-custom" onClick={() => { this.applyNow = true; handleSubmit() }}>Сохранить и применить</a>
                                    </div>
                                </div> */}

                                <button className="btn btn-primary-custom" type="submit">
                                    Сохранить
                                </button>

                                <button className="btn btn-secondary ml-2 btn-with-link" type="button">
                                    <Link to={this.state.returnUrl}>Назад</Link>
                                </button>
                            </div>
                        </Form>
                    )}
                </Formik>
            </div>
        );
    }
}

export default DisplaySettings;